export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const LOGOUT_ADMIN = "LOGOUT_ADMIN";

export const GET_USERS = "GET_USERS";
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const EDIT_USER = "EDIT_USER";
export const  BLOCK_USER = "BLOCK_USER";

export const GET_VISITORS = "GET_VISITORS";
export const ADD_VISITOR = "ADD_VISITOR";
export const DELETE_VISITOR = "DELETE_VISITOR";
export const EDIT_VISITOR = "EDIT_VISITOR";
export const  BLOCK_VISITOR = "BLOCK_VISITOR";

export const GET_PROJECTTYPES = "GET_PROJECTTYPES";
export const ADD_PROJECTTYPE = "ADD_PROJECTTYPE";
export const DELETE_PROJECTTYPE = "DELETE_PROJECTTYPE";
export const EDIT_PROJECTTYPE = "EDIT_PROJECTTYPE";

export const GET_ROLES = "GET_ROLES";
export const GET_PERMISSIONS_BY_ROLE = "GET_PERMISSIONS_BY_ROLE";
export const EMPTY_PERMISSIONS_BY_ROLE = "EMPTY_PERMISSIONS_BY_ROLE";
export const ADD_ROLE = "ADD_ROLE";
export const GET_MAIN_PERMISSIONS= "GET_MAIN_PERMISSIONS";
export const EDIT_PERMISSIONS = "EDIT_PERMISSIONS";

export const GET_CREATIVE_WORK = "GET_CREATIVE_WORK";

export const GET_EVALUATION_TYPE = "GET_EVALUATION_TYPE";
export const ADD_EVALUATION_TYPE = "ADD_EVALUATION_TYPE";
export const DELETE_EVALUATION_TYPE = "DELETE_EVALUATION_TYPE";
export const EDIT_EVALUATION_TYPEE = "EDIT_EVALUATION_TYPE";

export const GET_EVALUATION_DETAILS_TYPE = "GET_EVALUATION_DETAILS_TYPE";
export const EMPTY_EVALUATION_DETAILS_TYPE = "EMPTY_EVALUATION_DETAILS_TYPE";

export const GET_EVALUATION_DETAILS_BY_READER = "GET_EVALUATION_DETAILS_BY_READER";
export const EMPTY_EVALUATION_DETAILS_BY_READER = "EMPTY_EVALUATION_DETAILS_BY_READER";
export const DELETE_EVALUATION_DETAILS_BY_READER = "DELETE_EVALUATION_DETAILS_BY_READER";

export const GET_STATISTICS= "GET_STATISTICS";

export const SEND_NOTIFICATIONS = "SEND_NOTIFICATIONS";

export const GET_SETTING = "GET_SETTING";

export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";

export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
export const EDIT_PROFILE_DETAILS = "EDIT_PROFILE_DETAILS";

export const GET_WAREHOUSES = "GET_WAREHOUSES";
export const GET_ONE_WAREHOUSE = "GET_ONE_WAREHOUSE";
export const ADD_WAREHOUSE = "ADD_WAREHOUSE";
export const DELETE_WAREHOUSE = "DELETE_WAREHOUSE";
export const EDIT_WAREHOUSE = "EDIT_WAREHOUSE";

export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_ONE_PRODUCT  = "GET_ONE_PRODUCT";
export const EMPTY_ONE_PRODUCT  = "EMPTY_ONE_PRODUCT";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const EDIT_PRODUCT = "EDIT_PRODUCT";

export const GET_CATEGORIES = "GET_CATEGORIES";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const EDIT_CATEGORY = "EDIT_CATEGORY";

export const GET_SUB_CATEGORIES = "GET_SUB_CATEGORIES";
export const GET_SUB_CATEGORIES_BY_CATEGORY = "GET_SUB_CATEGORIES_BY_CATEGORY";
export const ADD_SUB_CATEGORY = "ADD_SUB_CATEGORY";
export const DELETE_SUB_CATEGORY = "DELETE_SUB_CATEGORY";
export const EDIT_SUB_CATEGORY = "EDIT_SUB_CATEGORY";

export const GET_PROJECTS = "GET_PROJECTS";
export const ADD_PROJECT = "ADD_PROJECT";
export const DELETE_PROJECT  = "DELETE_PROJECT ";
export const EDIT_PROJECT  = "EDIT_PROJECT ";

export const GET_SUPPLIERS = "GET_SUPPLIERS";
export const ADD_SUPPLY = "ADD_SUPPLY";
export const DELETE_SUPPLY = "DELETE_SUPPLY";
export const EDIT_SUPPLY = "EDIT_SUPPLY";


export const GET_SUPPLIERSS = "GET_SUPPLIERSS";
export const ADD_SUPPLIER = "ADD_SUPPLIER";
export const DELETE_SUPPLIER = "DELETE_SUPPLIER";
export const EDIT_SUPPLIER = "EDIT_SUPPLIER";

export const GET_REQUESTS = "GET_REQUESTS";
export const ADD_REQUEST = "ADD_REQUEST";
export const DELETE_REQUEST = "DELETE_REQUEST";
export const EDIT_REQUEST = "EDIT_REQUEST";

export const GET_ORDERS = "GET_ORDERS";
export const ADD_ORDER = "ADD_ORDER";
export const DELETE_ORDER = "DELETE_ORDER";
export const EDIT_ORDER = "EDIT_ORDER";


export const GET_DELIVERIES = "GET_DELIVERIES";
export const ADD_DELIVERY = "ADD_DELIVERY";
export const DELETE_DELIVERY = "DELETE_DELIVERY";
export const EDIT_DELIVERY = "EDIT_DELIVERY";

export const GET_ZONES_TYPE = "GET_ZONES_TYPE";
export const ADD_ZONE_TYPE = "ADD_ZONE_TYPE";
export const DELETE_ZONE_TYPE= "DELETE_ZONE_TYPE";

export const GET_ZONES = "GET_ZONES";
export const GET_ZONES_BY_WAREHOUSE = "GET_ZONES_BY_WAREHOUSE";
export const EMPTY_ZONES_BY_WAREHOUSE = "EMPTY_ZONES_BY_WAREHOUSE";
export const ADD_ZONE = "ADD_ZONE";
export const DELETE_ZONE= "DELETE_ZONE";
export const EDIT_ZONE= "EDIT_ZONE";

export const ADD_ACCOUNT = "ADD_ACCOUNT";
export const GET_ACCOUNTS = "GET_ACCOUNTS";
export const GET_ONE_ACCOUNT = "GET_ONE_ACCOUNT";
export const EMPTY_ONE_ACCOUNT = "EMPTY_ONE_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const EDIT_ACCOUNT = "EDIT_ACCOUNT";
export const PAGE_LIST_ACCOUNTS = "PAGE_LIST_ACCOUNTS";

export const GET_TRANSACTIONS = "GET_TRANSACTIONS";
export const CANCEL_TRANSACTION = "CANCEL_TRANSACTION";
export const ADD_TRANSACTION = "ADD_TRANSACTION";
export const EDIT_TRANSACTION = "EDIT_TRANSACTION";
export const PAGE_LIST_TRANSACTIONS = "PAGE_LIST_TRANSACTIONS";

export const GET_STATEMENTS = "GET_STATEMENTS";
export const GET_STATEMENTS_BY_ACCOUNT = "GET_STATEMENTS_BY_ACCOUNT";
export const EMPTY_STATEMENTS_BY_ACCOUNT = "EMPTY_STATEMENTS_BY_ACCOUNT";
export const GET_STATEMENTS_REPORT_BY_ACCOUNT = "GET_STATEMENTS_REPORT_BY_ACCOUNT";
export const EMPTY_STATEMENTS_REPORT_BY_ACCOUNT = "EMPTY_STATEMENTS_REPORT_BY_ACCOUNT";
export const GET_ONE_STATEMENT = "GET_ONE_STATEMENT";
export const EMPTY_ONE_STATEMENT = "EMPTY_ONE_STATEMENT";
export const ADD_STATEMENT = "ADD_STATEMENT";
export const PAGE_LIST_STATEMENT = "PAGE_LIST_STATEMENT";

export const GET_EXPENSES = "GET_EXPENSES";
export const GET_ONE_EXPENSE = "GET_ONE_EXPENSE";
export const EMPTY_ONE_EXPENSE = "EMPTY_ONE_EXPENSE";
export const ADD_EXPENSE = "ADD_EXPENSE";
export const DELETE_EXPENSE = "DELETE_EXPENSE";
export const EDIT_EXPENSE = "EDIT_EXPENSE";
export const PAGE_LIST_EXPENSE = "PAGE_LIST_EXPENSE";

export const ADD_SCRIPT_ARCHIVE = "ADD_SCRIPT_ARCHIVE";
export const DELETE_SCRIPT_ARCHIVE = "DELETE_SCRIPT_ARCHIVE";
export const PAGE_LIST_SCRIPT_ARCHIVE = "PAGE_LIST_SCRIPT_ARCHIVE";
export const GET_SCRIPTS_ARCHIVE = "GET_SCRIPTS_ARCHIVE";
export const ONE_SCRIPT_ARCHIVE = "ONE_SCRIPT_ARCHIVE";
export const EMPTY_SCRIPT_ARCHIVE = "EMPTY_SCRIPT_ARCHIVE";

export const ADD_ACCOUNT_TYPE = "ADD_ACCOUNT_TYPE";
export const DELETE_ACCOUNT_TYPE = "DELETE_ACCOUNT_TYPE";
export const GET_ACCOUNT_TYPES = "GET_ACCOUNT_TYPES";
export const EDIT_ACCOUNT_TYPE = "EDIT_ACCOUNT_TYPE";

export const SET_USER_ID = "SET_USER_ID";
export const GET_EXPENSES1 ='GET_EXPENSES1'

export const GET_VCARDS = "GET_VCARDS";

export const GET_PRODUCTS_BY_ZONE = "GET_PRODUCTS_BY_ZONE";
export const EMPTY_PRODUCTS_BY_ZONE = "EMPTY_PRODUCTS_BY_ZONE";
export const ASSIGN_PRODUCT_TO_ZONE = "ASSIGN_PRODUCT_TO_ZONE";

export const LOAD_ZONE_WAREHOUSE = "LOAD_ZONE_WAREHOUSE";